import type { QueryClient } from '@tanstack/react-query';
import { shopifyKeys } from '../queryKeys';

/** Reloads everything a coupon write can change: config, coupon lists and
 *  summary, conversions, every creator-picker search, and the brand-wide glance. */
export function refreshCampaignShopify(qc: QueryClient, campaignId: string): void {
  void qc.invalidateQueries({ queryKey: shopifyKeys.campaignConfig(campaignId) });
  void qc.invalidateQueries({ queryKey: shopifyKeys.campaignCoupons(campaignId) });
  void qc.invalidateQueries({ queryKey: shopifyKeys.conversions(campaignId) });
  void qc.invalidateQueries({ queryKey: shopifyKeys.campaignCreatorsAll(campaignId) });
  void qc.invalidateQueries({ queryKey: shopifyKeys.glance() });
}
